import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperImage from "../../assets/CarouselImage/swipe_img.png"
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

// import required modules
import { Pagination , Autoplay} from 'swiper/modules';

export default function CategoryProfile({banner}) {
  return (
    <>
      <Swiper
        className="my-swiper-category h-full"
        pagination={true} 
        modules={[Pagination, Autoplay]}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
      >
        {banner?.map((item, index) => {
          return (
            <SwiperSlide>
              <div key={index}>
                <img
                  className='w-full max-sm:rounded-none rounded-t-[20px]'
                  alt={`img${index + 1}`}
                  src={item}
                />
              </div>
            </SwiperSlide>)
        })}
      </Swiper>
    </>
  );
}

